/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAIIntegrationConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetAIIntegrationConfigRequest = {
  /**
   * AI provider identifier. Supported values include cursor, anthropic_compliance, codex_compliance, and chatgpt_compliance.
   */
  provider: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetAIIntegrationConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAIIntegrationConfigSecurity$outboundSchema: z.ZodMiniType<
  GetAIIntegrationConfigSecurity$Outbound,
  GetAIIntegrationConfigSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAIIntegrationConfigSecurityToJSON(
  getAIIntegrationConfigSecurity: GetAIIntegrationConfigSecurity,
): string {
  return JSON.stringify(
    GetAIIntegrationConfigSecurity$outboundSchema.parse(
      getAIIntegrationConfigSecurity,
    ),
  );
}

/** @internal */
export type GetAIIntegrationConfigRequest$Outbound = {
  provider: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAIIntegrationConfigRequest$outboundSchema: z.ZodMiniType<
  GetAIIntegrationConfigRequest$Outbound,
  GetAIIntegrationConfigRequest
> = z.pipe(
  z.object({
    provider: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getAIIntegrationConfigRequestToJSON(
  getAIIntegrationConfigRequest: GetAIIntegrationConfigRequest,
): string {
  return JSON.stringify(
    GetAIIntegrationConfigRequest$outboundSchema.parse(
      getAIIntegrationConfigRequest,
    ),
  );
}
